import React from 'react';
import styled from '@emotion/styled';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import theme from '../../../../styles/themes/hopeTheme';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  margin: 0 auto;
  font-weight: bold;
  font-size: 11px;
  line-height: 1.64;
  padding: 16px 0;
  font-family: ${theme.headerBold};
  @media screen and (min-width: 768px) {
    flex-direction: row;
  }
  @media screen and (min-width: 1440px) {
    font-size: 14px;
    line-height: 1.57;
  }
`;

const ArrowForward = styled(ArrowForwardIcon)`
  padding-left: 8px;
`;

const PromoOneContainer = styled.div<any>`
  background-color: ${props =>
    props.backgroundColor ? props.backgroundColor : '#ffeded'};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 4px;
  color: ${props => (props.textColor ? props.textColor : theme.textColor)};
  margin-right: 16px;
  margin-left: 16px;
  padding: 0 16px;
  height: 48px;
  @media screen and (min-width: 768px) {
    width: 100%;
  }
  &:hover {
    cursor: pointer;
  }
`;

const PromoTwoContainer = styled.div<any>`
  background-color: ${props =>
    props.backgroundColor ? props.backgroundColor : '#e7f3ff'};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 4px;
  color: ${props => (props.textColor ? props.textColor : theme.textColor)};
  margin-left: 16px;
  padding: 0 16px;
  height: 48px;
  margin-right: ${props => (props.hasTwoPromos ? '0px' : '16px')};
  @media screen and (min-width: 768px) {
    width: 100%;
  }
  @media screen and (max-width: 767px) {
    margin-bottom: ${props => (props.hasTwoPromos ? '16px' : '0px')};
    margin-right: 16px;
  }
  &:hover {
    cursor: pointer;
  }
`;

interface PromoSnackBarProps {
  config: {
    promotionTextOne?: string;
    promotionTextTwo?: string;
    promoOneColor?: string;
    promoTwoColor?: string;
    linkOne?: string;
    linkTwo?: string;
    textOneColor?: string;
    textTwoColor?: string;
    flashSaleEndDate?: string;
  };
  handleRouteChange: (input: string) => void;
}

export default function PromoSnackBar({
  config,
  handleRouteChange,
}: PromoSnackBarProps) {
  const {
    promotionTextOne,
    promoOneColor,
    promoTwoColor,
    promotionTextTwo,
    linkOne,
    linkTwo,
    textOneColor,
    textTwoColor,
    flashSaleEndDate,
  } = config;

  const onClickPromoOne = () => {
    if (linkOne) {
      handleRouteChange(linkOne);
    }
  };

  const onClickPromoTwo = () => {
    if (config) {
      if (linkTwo) {
        handleRouteChange(linkTwo);
      }
    }
  };

  const getDaysLeft = (date: string | undefined | null) => {
    if (!date) return '';
    const oneDay = 24 * 60 * 60 * 1000;
    const today = new Date();
    const endDateAsDate = new Date(date);
    const daysLeft = Math.round(
      (endDateAsDate.getTime() - today.getTime()) / oneDay,
    );
    if (daysLeft > 1) return `${daysLeft} days`;
    return `1 day`;
  };

  const hasTwoPromos = promotionTextOne && promotionTextTwo;
  const isFlashSale = !!flashSaleEndDate;
  return (
    <Container>
      {promotionTextTwo && (
        <PromoTwoContainer
          hasTwoPromos={hasTwoPromos}
          backgroundColor={promoTwoColor}
          textColor={textTwoColor}
          onClick={onClickPromoTwo}
        >
          {isFlashSale
            ? `FLASH SALE! ${getDaysLeft(
                flashSaleEndDate,
              )} left ${promotionTextTwo}`
            : promotionTextTwo}
          <ArrowForward fontSize="small" />
        </PromoTwoContainer>
      )}
      {promotionTextOne && (
        <PromoOneContainer
          backgroundColor={promoOneColor}
          textColor={textOneColor}
          onClick={onClickPromoOne}
        >
          {promotionTextOne}
        </PromoOneContainer>
      )}
    </Container>
  );
}
